<div *ngIf="!node.block" class="mat-card tripetto-block mat-elevation-z2">
  <div class="mat-card-title" *ngIf="name" markdown [content]="name" [context]="context"></div>
  <p *ngIf="description" markdown [content]="description" [context]="context"></p>
</div>
